import React from "react";
import { Button, Group, TextInput } from "@mantine/core";
import { IconDownload, IconSearch } from "@tabler/icons";
import i18n from "../../../i18n";

export function matchesQuery(query, parts) {
  const terms = String(query || "")
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);
  if (!terms.length) return true;
  const haystack = parts
    .filter((part) => part != null && part !== false)
    .join(" ")
    .toLowerCase();
  return terms.every((term) => haystack.includes(term));
}

const escapeXml = (value) =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const excelCell = (value) => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return `<Cell><Data ss:Type="Number">${value}</Data></Cell>`;
  }
  return `<Cell><Data ss:Type="String">${escapeXml(value ?? "")}</Data></Cell>`;
};

export function buildExcelXml(headers, rows) {
  const header = `<Row>${headers.map((item) => excelCell(String(item))).join("")}</Row>`;
  const body = rows
    .map((row) => `<Row>${row.map((cell) => excelCell(cell)).join("")}</Row>`)
    .join("");
  return `<?xml version="1.0"?>
<?mso-application progid="Excel.Sheet"?>
<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">
<Worksheet ss:Name="List"><Table>${header}${body}</Table></Worksheet>
</Workbook>`;
}

export function payrollFileName(prefix, code) {
  const safe = String(code || "payroll").replace(/[^\w.-]+/g, "_");
  return `${prefix}-${safe}.xls`;
}

export function downloadExcel(filename, headers, rows) {
  const blob = new Blob([buildExcelXml(headers, rows)], {
    type: "application/vnd.ms-excel",
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename.endsWith(".xls") ? filename : `${filename}.xls`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

export const ResultTools = ({
  query,
  onQueryChange,
  onDownload,
  placeholder,
}) => (
  <Group spacing="xs" noWrap>
    <TextInput
      size="xs"
      icon={<IconSearch size={14} />}
      placeholder={placeholder || i18n.t("Search")}
      value={query}
      onChange={(event) => onQueryChange(event.currentTarget.value)}
      style={{ width: 240 }}
    />
    <Button
      size="xs"
      variant="light"
      leftIcon={<IconDownload size={14} />}
      onClick={onDownload}
    >
      {i18n.t("Download Excel")}
    </Button>
  </Group>
);
